// The nav's contents live apart from the component that draws them, so that
// App can bind the same list to number-key shortcuts without importing a
// non-component value out of AppShell (which would break fast refresh).

/** Screens reachable from the nav, in the order they appear there. */
export type NavTarget =
  | "worldMap"
  | "location"
  | "schedule"
  | "journal"
  | "skills"
  | "army"
  | "factions"
  | "spirit"
  | "history"

/** Nav order is also shortcut order: the nth entry is opened by pressing n. */
export const NAV_ITEMS: Array<{ target: NavTarget; label: string }> = [
  { target: "worldMap", label: "World Map" },
  { target: "location", label: "Current Location" },
  { target: "schedule", label: "Schedule" },
  { target: "journal", label: "Journal" },
  { target: "skills", label: "Skills" },
  { target: "army", label: "Army" },
  { target: "factions", label: "Factions" },
  { target: "spirit", label: "The Spirit" },
  { target: "history", label: "Chronicle" },
]
